import { TextField } from "@mui/material";

const InputText = (props) => {
  return (
    <TextField
      {...props}
      variant={"filled"}
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default InputText;
